'use client'

import { Controller, useFormContext } from 'react-hook-form'
import { Cell, Checkbox } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { Field, FormModel } from './types'

const EnglishAllowedCheckbox = () => {
  const { control } = useFormContext<FormModel>()
  const translate = useTranslate('help_contact_form.english_allowed')

  return (
    <Cell
      body={translate('explanation')}
      suffix={
        <Controller
          name={Field.IsEnglishAllowed}
          control={control}
          defaultValue={false}
          render={({ field: { value, name, onChange } }) => (
            <div data-testid="english-allowed">
              <Checkbox
                name={name}
                checked={value}
                onChange={event => onChange(event.target.checked)}
              />
            </div>
          )}
        />
      }
    />
  )
}

export default EnglishAllowedCheckbox
